import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_SECURITY_API } from '../utils/AxoisUtilComponent';
import { formatDate } from '../utils/timeUtils';
import TemplateListView    from "./TemplateListView";
import DatakeyAdminDetailsView from "./DatakeyAdminDetailsView";
import DatakeyAdminNewView     from "./DatakeyAdminNewView";


const DatakeyAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "DatakeyAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'id',
      name: t("I18N_Key_id"),
      sortable: true,
      sortField: 'id',
      grow: 1,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Key_value") + ' (' + t("I18N_Encrypted") + ')',
      selector: row => row.keyValue,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Key_IV") + ' (' + t("I18N_Encrypted") + ')',
      selector: row => row.ivValue,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Key_owner"),
      selector: row => row.ownerUsername,
      sortable: true,
      grow: 1
    },
    {
      name: t("I18N_Time_created"),
      selector: row => formatDate(row.timeCreated),
      grow: 1.25,
      wrap: true
    }
  ];

  // ----- END - Data Table stuff -----

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_SECURITY_API}
                                                  apiObjName={'data-keys'}
                                                  listPageTitle={t("I18N_Datakey_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_datakey")}
                                                  searchTooltip={t("I18N_Search")}
                                                  tableColumns={tableColumns}
                                                  hideDeleteIcon={true}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DatakeyAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DatakeyAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DatakeyAdmin;
